import React, { useEffect, useState } from "react";
import {
  Popover,
  OverlayTrigger,
  Tab,
  Tabs,
} from "react-bootstrap";
import Moment from "react-moment";
import InternalReviewPopup from "./InternalReviewPopup";
import CandidateReqDoc from "../OMCRegistry/CandidateReqDoc";
import { getCurrentClientDeatils, getCurrentUser, loadClientDetails } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  addComment, getCommentAddedStatus, getCommentUpdatedStatus,
  loadAppComments, updateComment
} from "../../app/store/comments";
import {
  deleteDocument, deleteReqDocument, getDocumentDeleteStatus,
  getDocumentPurgeStatus, getDocumentRollbackStatus, getDocuments,
  getDocumentsSendStatus, getEsignDocuments, getReqDocDeleteStatus, getReqDocSendStatus,
  getReqDocuments, getSignedDocumentData, getWfPhasesDoc, getesignDocumentsSendStatus, loadDocuments, loadEsignDocuments,
  loadReqDocuments, loadSignedDocument, loadWfPhasesDocs, purgeDocument, rollbackDocument, sendDocuments,
  sendReqDocuments, signedDocumentReceived, updateReceivedDocStatus
} from "../../app/store/documents";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import useDocDownload from "../../app/hooks/useDocDownload";
import UploadOther from "../../app/components/Document/UploadOther";
import GenerateContract from "../../app/components/Contract/GenerateContract";
import { getSubsCurrentWfTask, loadSubcontractorWfTask } from "../../app/store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask } from "../../app/store/recruiter";
import moment from "moment";

const Document = (props) => {
  const { workflowTask, uploadType, app, item: applicantObj, viewType, pageModule, handleCloseDocumentView, type } = props;

  const [appDocuments, setAppDocuments] = useState([]);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [selectedDocIds, setSelectedDocIds] = useState([]);
  const [sendType, setSendType] = useState("");
  const [docShowHide, setDocShowHide] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [otherDocShowHide, setOtherDocShowHide] = useState(false);
  const [contractShowHide, setContractShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState(null);
  const [copyItem, setCopyItem] = useState("");
  const [esignDocuments, setEsignDocuments] = useState([]);
  const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
  const [signLoading, setSignLoading] = useState(false);
  const [onReqDocs, setOnReqDocs] = useState([]);
  const [clientDetails, setClientDetails] = useState(null);
  const [defaultActiveKey, setDefaultActiveKey] = useState(2);
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [partnerAppData, setPartnerAppData] = useState(null);
  const [achCheckCount, setAchCheckCount] = useState(0);

  const appDocumentSelector = useSelector(getDocuments);
  const updateCommentsSelector = useSelector(getCommentUpdatedStatus);
  const documentSendStatusSelector = useSelector(getDocumentsSendStatus);
  const esignDocumentSendStatusSelector = useSelector(getesignDocumentsSendStatus);
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);
  const documentPurgeStatusSelector = useSelector(getDocumentPurgeStatus);
  const documentRollbackStatusSelector = useSelector(getDocumentRollbackStatus);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const commentAddedStatusSelector = useSelector(getCommentAddedStatus);
  const reqDocSendStatusSelector = useSelector(getReqDocSendStatus);
  const reqDocDeleteStatusSelector = useSelector(getReqDocDeleteStatus);
  const esignDocumentsSelector = useSelector(getEsignDocuments);
  const signedDocumentDataSelector = useSelector(getSignedDocumentData);
  const getWfPhasesDocSelector = useSelector(getWfPhasesDoc);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (!currentClientDeatilsSelector)
      dispatch(loadClientDetails());
  }, [])

  useEffect(() => {
    if (workflowTask?.ciid > 0) {
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadReqDocuments(workflowTask.ciid));
      setPartnerCurrentWfTask(workflowTask);
      if (applicantObj?.id) dispatch(loadEsignDocuments(applicantObj?.id));
      loadReqDocTypes();
      // setPartnerCurrentWfTask(null);
      // if (applicantObj?.subcontractor?.parentid > 0 && uploadType === "Subcontractor")
      //   dispatch(loadSubcontractorWfTask(applicantObj?.subcontractor?.parentid));
      // if (applicantObj?.recruiter?.parentid > 0 && uploadType === "Recruiter")
      //   dispatch(loadRecruiterWfTask(applicantObj?.recruiter?.parentid))
    }
    // else {
    //   setPartnerCurrentWfTask(null);
    //   if (applicantObj?.subcontractor?.parentid > 0 && uploadType === "Subcontractor") {
    //     dispatch(loadSubcontractorWfTask(applicantObj?.subcontractor?.parentid));
    //   }

    //   if (applicantObj?.recruiter?.parentid > 0 && uploadType === "Recruiter")
    //     dispatch(loadRecruiterWfTask(applicantObj?.recruiter?.parentid))

    //   loadReqDocTypes();
    // }
  }, [workflowTask, uploadType]);

  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      dispatch(loadDocuments(subsCurrentWfTaskSelector.ciid));
      dispatch(loadReqDocuments(subsCurrentWfTaskSelector.ciid));
      if (applicantObj?.subcontractor?.parentid) dispatch(loadEsignDocuments(applicantObj?.subcontractor?.parentid));
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setPartnerAppData(subsCurrentWfTaskSelector.appData)
      setAchCheckCount(1)
    }
  }, [subsCurrentWfTaskSelector])

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      dispatch(loadDocuments(recCurrentWfTaskSelector.ciid));
      dispatch(loadReqDocuments(recCurrentWfTaskSelector.ciid));
      if (applicantObj?.recruiter?.parentid) dispatch(loadEsignDocuments(applicantObj?.recruiter?.parentid));
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setPartnerAppData(recCurrentWfTaskSelector.appData)
      setAchCheckCount(1);
    }
  }, [recCurrentWfTaskSelector])

  const loadReqDocTypes = () => {
    //if (workflowTask?.ciid && viewType !== "candidateList") {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      if (app?.applicationType === "Subcontractor Application") {
        dispatch(loadWfPhasesDocs("Subcontractors Required Docs"))
      } else if (app?.applicationType === "Recruiter Application") {
        dispatch(loadWfPhasesDocs("Recruiters Required Docs"))
      } else if (app?.applicationType === "C2C Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("C2C Candidates Required Docs"))
      } else if (app?.applicationType === "W2 Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("W2 Candidates Required Docs"))
      } else if (app?.applicationType === "1099 Candidate Onboarding") {
        dispatch(loadWfPhasesDocs("1099 Candidates Required Docs"))
      }
    }
    else {
      if (uploadType === "Subcontractor")
        dispatch(loadWfPhasesDocs("Candidate Required Doc From Subcontractor"))
      // else if (uploadType === "Recruiter")
      //   dispatch(loadWfPhasesDocs("Recruiters Required Docs"))
    }
  }

  useEffect(() => {
    setOnReqDocs(getWfPhasesDocSelector);
  }, [getWfPhasesDocSelector])

  useEffect(() => {
    if (appDocumentSelector.length > 0) {
      let filterDocs = appDocumentSelector.filter(x => x.uploadType !== "req");
      setAppDocuments(filterDocs);
    } else {
      setAppDocuments([]);
    }
  }, [appDocumentSelector]);

  useEffect(() => {
    if (documentSendStatusSelector && workflowTask?.ciid) {
      getAlert("", "Document Sent Successfully", "success");
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadReqDocuments(workflowTask.ciid));
    }
  }, [documentSendStatusSelector]);

  useEffect(() => {
    if (esignDocumentSendStatusSelector && workflowTask?.ciid) {
      getAlert("", "Document Sent Successfully", "success");
      dispatch(loadDocuments(workflowTask.ciid));
    }
  }, [esignDocumentSendStatusSelector]);

  useEffect(() => {
    setEsignDocuments(esignDocumentsSelector);
  }, [esignDocumentsSelector])

  useEffect(() => {
    setClientDetails(currentClientDeatilsSelector);
  }, [currentClientDeatilsSelector])

  useEffect(() => {
    if (updateCommentsSelector && workflowTask?.ciid) {
      dispatch(loadAppComments("document", workflowTask.ciid));
    }
  }, [updateCommentsSelector]);

  useEffect(() => {
    if (reqDocumentsSelector)
      setReqDocuments(reqDocumentsSelector);
    else
      setReqDocuments([]);
  }, [reqDocumentsSelector])

  const handleModalShowHide = (item) => {
    setShowHide(!showHide);
    setSelectedObj(item);
  };

  const handleSubmit = async ({ comments }) => {
    const wfTask = { ...workflowTask };
    wfTask.performerId = currentUser.id;
    const frmData = new FormData();
    frmData.append("comment", comments);
    frmData.append("type", "document");
    frmData.append("workflowTask", JSON.stringify(wfTask));
    dispatch(addComment(frmData));
    setShowHide(false);
  };

  useEffect(() => {
    if (commentAddedStatusSelector && workflowTask?.ciid) {
      dispatch(loadAppComments("document", workflowTask.ciid));
    }

  }, [commentAddedStatusSelector])

  const handleEditComment = async (item) => {
    dispatch(updateComment(item));
    setShowHide(false);
  };

  const handleDocShowHide = (type) => {
    if (type === "save") {
      setDocShowHide(false);
      setSendType("")

      if (workflowTask?.ciid && viewType !== "candidateList")
        dispatch(loadDocuments(workflowTask.ciid))
      else if (partnerCurrentWfTask?.ciid)
        dispatch(loadDocuments(partnerCurrentWfTask?.ciid));

    } else {
      setDocShowHide(!docShowHide);
      setSendType(type);
    }
  };

  const handleSendSelect = ({ currentTarget }) => {
    const id = currentTarget.id.replace("chk", "");
    const filterData = selectedDocIds.filter((x) => x !== id);
    if (currentTarget.checked) filterData.push(id);
    setSelectedDocIds(filterData);
  };

  const handleSendDoc = async (id) => {
    const docIds = [id];
    const frm = new FormData();
    frm.append("ids", docIds);
    frm.append("userId", currentUser.id);
    frm.append("ciid", workflowTask?.ciid);
    const result = await getConfirmAlert("Warning", "Are you sure you want to send this Document?", "warning");
    if (result.isConfirmed)
      dispatch(sendDocuments(frm));
  };

  const handleSendAllDoc = async () => {
    if (selectedDocIds.length > 0) {
      const frm = new FormData();
      frm.append("ids", selectedDocIds);
      frm.append("userId", currentUser.id);
      frm.append("ciid", workflowTask?.ciid);
      const result = await getConfirmAlert("Warning", "Are you sure you want to send this Document?", "warning");
      if (result.isConfirmed)
        dispatch(sendDocuments(frm))
    } else {
      getAlert("", "Selected documents are sent", "error");
    }
  };

  const handleDeleteDocument = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Delete this Document?", "warning");
    if (result.isConfirmed)
      dispatch(deleteDocument(id));
  };

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Document Deleted Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (workflowTask?.ciid) {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadReqDocuments(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentDeleteStatusSelector])

  const handlePurgeDocument = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Purge this Document?", "warning");
    if (result.isConfirmed) dispatch(purgeDocument(id));
  };

  useEffect(() => {
    if (documentPurgeStatusSelector) {
      getAlert("", "Document Purged Successfully", "success");
      if (workflowTask?.ciid && viewType !== "candidateList") {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadReqDocuments(workflowTask.ciid));
      }
      else if (partnerCurrentWfTask?.ciid) {
        dispatch(loadDocuments(partnerCurrentWfTask.ciid));
        dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      }
    }
  }, [documentPurgeStatusSelector])

  const handleRollbackDocument = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Rollback this Document?", "warning");
    if (result.isConfirmed)
      dispatch(rollbackDocument(id));
  };

  useEffect(() => {
    if (documentRollbackStatusSelector) {
      getAlert("", "Document Rollbacked Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (workflowTask?.ciid) {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadReqDocuments(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentRollbackStatusSelector])

  const handleOtherDocShowHide = (type) => {
    setOtherDocShowHide(!otherDocShowHide);
    if (type === "save") {
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (workflowTask?.ciid) {
        dispatch(loadReqDocuments(workflowTask.ciid));
        dispatch(loadDocuments(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadReqDocuments(partnerCurrentWfTask?.ciid));
      //   dispatch(loadDocuments(partnerCurrentWfTask?.ciid));
      // }
    }
  }

  const getReqUploadedDocs = (item, type) => {

    const achDocs = appDocuments.filter(
      (x) => x.updType === `req_${!item.id ? item.docId : item.id}`
    );
    if (achDocs.length === 0) {
      return <>
        {/* <td></td> */}
        <td>
          {type === "req" ? "Pending" : "Done"}
        </td>
      </>
    }

    if (achDocs.length > 0) {
      const doc = achDocs[0];
      return <>
        {/* <td>
          <button
            className="btn btn-link btn-sm p-0"
            title="Download Document"
            onClick={() => handleDownloadFile(doc)
            }
          >
            {doc.docName}
          </button>
          {getPopover(doc.remarks)}
        </td> */}
        <td>Done</td>
      </>
    }
  }

  const handleViewSignedDoc = (item, type) => {
    setSelectedSignedDoc(item);
    setSignLoading(true);
    dispatch(loadSignedDocument(item.id, type));
  }

  useEffect(() => {
    if (signedDocumentDataSelector && selectedSignedDoc) {
      const url = window.URL.createObjectURL(signedDocumentDataSelector);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";

      if (selectedSignedDoc?.docName)
        link.setAttribute("download", selectedSignedDoc.docName);
      else if (selectedSignedDoc?.documentName)
        link.setAttribute("download", selectedSignedDoc.documentName);
      else
        link.setAttribute("download", "ipcs_document");

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setSelectedSignedDoc(null);
      setSignLoading(false);
      dispatch(signedDocumentReceived(null));
    }
  }, [signedDocumentDataSelector])

  const handleContractShowHide = (type) => {
    if (type === "save") {
      //if (workflowTask?.ciid && viewType !== "candidateList")
      if (workflowTask?.ciid)
        dispatch(loadDocuments(workflowTask.ciid))
      // else if (partnerCurrentWfTask?.ciid)
      //   dispatch(loadDocuments(partnerCurrentWfTask?.ciid));

      setContractShowHide(false);
    }
    else {
      setContractShowHide(!contractShowHide);
    }
  }

  const handleSendReqDocument = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Send this Document?", "warning");
    if (result.isConfirmed)
      dispatch(sendReqDocuments(id));
  }

  const handleDeleteReqDocument = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to Delete this Document?", "warning");
    if (result.isConfirmed)
      dispatch(deleteReqDocument(id));
  }

  useEffect(() => {
    if (reqDocSendStatusSelector) {
      getAlert("", "Document Sent Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (workflowTask?.ciid) {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadReqDocuments(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [reqDocSendStatusSelector]);

  useEffect(() => {
    if (reqDocDeleteStatusSelector && workflowTask?.ciid) {
      getAlert("", "Document Delete Successfully", "success");
      //if (workflowTask?.ciid && viewType !== "candidateList") {
      if (workflowTask?.ciid) {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadReqDocuments(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
      // }
    }
  }, [reqDocDeleteStatusSelector]);

  const handleDocumentLoad = () => {
    //if (workflowTask?.ciid && viewType !== "candidateList") {
    if (workflowTask?.ciid) {
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadReqDocuments(workflowTask.ciid));
      if (applicantObj?.id) dispatch(loadEsignDocuments(applicantObj?.id));
    }
    // else if (partnerCurrentWfTask?.ciid) {
    //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
    //   dispatch(loadReqDocuments(partnerCurrentWfTask.ciid));
    //   if (applicantObj?.subcontractor?.parentid > 0 && uploadType === "Subcontractor") dispatch(loadEsignDocuments(applicantObj?.subcontractor?.parentid));
    //   if (applicantObj?.recruiter?.parentid > 0 && uploadType === "Recruiter") dispatch(loadEsignDocuments(applicantObj?.recruiter?.parentid));
    // }
  }

  const handleCopyClipboard = (text) => {
    navigator.clipboard.writeText(window.location.origin + text);
    setCopyItem(window.location.origin + text);
    setTimeout(() => {
      setCopyItem("");
    }, 3000);
  }

  const handleDocStatusChange = (docId, status) => {
    dispatch(updateReceivedDocStatus(docId, status));
  }

  const getSignedDocuments = (item, signType) => {
    const signDoc = esignDocuments.filter(x => x.docData === item.docData);
    if (signDoc.length === 0) {
      var chkFirstSign = esignDocuments.filter(x => x.docData === item.docData && x.status === true && x.signedStatus === "0" && x.sendStatus !== true);
      if (chkFirstSign.length > 0) {
        return <>
          {item.docType === "application/pdf" && (
            <a
              className="btn btn-sm btn-link p-0"
              target="blank"
              //onClick={() => handleSendeSignDoc(item.docId)}
              href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${chkFirstSign[0]?.id}_${(((uploadType === "Subcontractor" || uploadType === "Recruiter") && viewType !== "candidateList")
                || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask?.ciid : partnerCurrentWfTask?.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.docName}_contractSigned`}
            >

              WF eSign
            </a>
          )}
          <br />
          <span>Pending</span>
        </>
      }
      else {
        var chkSingleSign = esignDocuments.filter(x => x.docData === item.docData && x.signedStatus === null && x.sendStatus === true);

        if (chkSingleSign.length > 0 && signType === "0") return <><span>Not Applicable</span></>
        return <span>Pending</span>;
      }
    }

    if (signDoc.length > 0) {
      const doc = signDoc[0];
      const docSignType = signDoc.filter(x => x.signedStatus === signType);
      if (docSignType.length === 0 && doc.signedStatus !== "1") return <>
        {item.docType === "application/pdf" && !item.sentStatus && (
          <a
            className="btn btn-sm btn-link p-0"
            target="blank"
            //onClick={() => handleSendeSignDoc(item.docId)}
            href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${signDoc[0]?.id}_${(((uploadType === "Subcontractor" || uploadType === "Recruiter") && viewType !== "candidateList")
              || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask?.ciid : partnerCurrentWfTask?.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.docName}_contractSigned`}
          >

            WF eSign
          </a>
        )}
        <br />
        <span>{signType === "0" ? "Not Applicable" : "Pending"}</span>
      </>;

      if (docSignType.length === 0 && doc.signedStatus === "1" && doc.signedDocUrl === null) return <>
        <span>Not Applicable</span>
      </>

      return <>
        <button
          className="btn btn-link btn-sm p-0"
          title="Download Document"
          onClick={() => handleViewSignedDoc(doc, signType)
          }
        >
          Download/View
        </button>
        <br />
        <span>Done</span>
      </>
    }
  }

  const getDocReqSize = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentSelector.filter(x => x.uploadId === item.refDocId);
      if (findDocs.length > 0) {
        return <>
          {findDocs.map(doc =>
            <td>
              {doc.docSize}
            </td>
          )}
        </>
      }
    } else {
      return <>
        <td>

        </td>
      </>
    }

  }

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentSelector.filter(x => x.uploadId === item.refDocId);
      if (findDocs.length > 0) {
        return <>
          {findDocs.map(doc =>
            <td>
              <button
                className="btn btn-link btn-sm p-0"
                title="Download Document"
                onClick={() => handleDownloadFile(doc)}
              >
                {doc.docName}
              </button>
              <br />
              {item.documnetName}
            </td>
          )}
        </>
      }
    }

    return <td>
      {item.documnetName}
    </td>
  }

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <React.Fragment>
        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
          <span
            className="btn-sm btn-link text-primary p-0"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}
          >
            {/* <i className="fa fa-info-circle"></i> */}
            View
          </span>
        </OverlayTrigger>
      </React.Fragment>
    );
  };

  const normalizeDate = (dt) => {
    if (!dt) return 0;
    return new Date(dt).getTime(); // safely converts ISO-like strings
  };


  const clientDocs = appDocuments.filter((x) => x.uploadType === "agency");
  const mspDocs = appDocuments.filter((x) => x.uploadType === "msp");
  let filterDocs = appDocuments.filter((x) => x.updType !== "Messaging" && x.deleteFlag !== true);

  let filterAgencyMspDocs = uploadType === "msp" ? mspDocs : clientDocs;
  let receviedDocumnets = filterDocs.filter((x) => !x.uploadType?.includes("_c2c_"))

  const ppDocs = filterDocs.filter((x) => x.uploadType?.includes("_c2c_") && x.sentStatus === true);
  if (ppDocs.length > 0) {
    receviedDocumnets = [...receviedDocumnets, ...ppDocs];
  }

  let sentDocuments = filterDocs.filter((x) => x.deleteFlag !== true && x.uploaderId !== applicantObj?.id);

  let filterReqDocs = reqDocuments.filter(x => x.performerId === applicantObj?.id);

  if (applicantObj?.subcontractor?.parentid > 0 && uploadType === "Subcontractor") {
    sentDocuments = filterDocs.filter((x) => x.deleteFlag !== true
      && x.uploaderId !== applicantObj?.subcontractor?.parentid
      && x.uploaderId !== applicantObj?.id
      && x.receiverId !== applicantObj?.id);

    filterReqDocs = reqDocuments.filter(x => x.performerId === applicantObj?.subcontractor?.parentid);
  }

  
  if (applicantObj?.recruiter?.parentid > 0 && uploadType === "Recruiter") {
    sentDocuments = filterDocs.filter((x) => x.deleteFlag !== true
      && x.uploaderId !== applicantObj?.recruiter?.parentid
      && x.uploaderId !== applicantObj?.id
      && x.receiverId !== applicantObj?.id);

    filterReqDocs = reqDocuments.filter(x => x.performerId === applicantObj?.recruiter?.parentid);
  }

  const sentAgencyMapDocuments = filterAgencyMspDocs.filter((x) => x.deleteFlag !== true)

  const deletedDocumnets = appDocuments.filter((x) => x.deleteFlag === true)
  const deletedAgencyMspDocumnets = appDocuments.filter((x) => x.deleteFlag === true && x.uploadType === `${uploadType}`);

  let mergeReceivedDocs = [...sentDocuments.filter(
    (x) =>
      x.uploadType !== "client" &&
      x.uploadType !== "reporting" &&
      x.uploadType !== "project" &&
      x.uploadType !== "agency" &&
      x.uploadType !== "msp" &&
      x.uploadType !== "ProjectInfo" &&
      x.updType !== "internal" &&
      x.updType !== "Invoice" &&
      !x.updType?.includes("req_")
  )
    .map((x) => ({
      ...x,
      __docType: "sent",
      finalDateTime: moment(x.dateTime), // moment object
    })),
  ...filterReqDocs.map((f) => ({
    ...f,
    __docType: "req",
    finalDateTime: moment(f.addedDateTime), // moment object
  }))];

  let sortMergedDocs = mergeReceivedDocs.sort((a, b) => b.finalDateTime.valueOf() - a.finalDateTime.valueOf());
  return (
    <React.Fragment>
      <Tabs defaultActiveKey={defaultActiveKey} id="uncontrolled-tab-example">
        <Tab
          eventKey={2}
          title={<>Upload <div className="dropdown">
            <button
              className="btn btn-outline-default btn-sm dropdown-toggle mr-0"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              title="Upload Document"
            >
              <i class="fa fa-paperclip" aria-hidden="true"></i>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {(uploadType !== "agency" && uploadType !== "msp") && (
                <>
               
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleContractShowHide()}
                  >
                    Generate Documents
                  </button>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleDocShowHide("repository")}
                    disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
                  >
                    Upload from DDRMS Repository
                  </button>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => setOtherDocShowHide("other")}
                    disabled={viewType === "candidateList" && (uploadType === "Recruiter" || type === "candetails")}
                  >
                    Upload Required Document
                  </button>
                </>)}
              <button
                type="button"
                className="dropdown-item"
                onClick={() => handleDocShowHide("upload")}
                disabled={viewType === "candidateList" && (uploadType === "Subcontractor" || uploadType === "Recruiter")}
              >
                Upload from Local Drive
              </button>
            </div>
          </div></>}
          className="p-3 border"
          tabClassName="h4"
        >
          <div className="row">
            <div className="col-md-12 text-left">

              <button
                className="btn btn-sm btn-link pl-0 mr-0"
                onClick={handleDocumentLoad}
              >
                Refresh
              </button>
              {(uploadType !== "agency" && uploadType !== "msp") && (
                <>| <button
                  className="btn btn-sm btn-link"
                  onClick={handleSendAllDoc}
                >
                  Send All Selected Documents
                </button>
                </>
              )}
            </div>

            <div className="col-md-12 mt-1">
              <div className="table-responsive">
                <table className="table table-striped align-items-center table-flush border">
                  <thead className="thead-light-green">
                    <tr>
                      {(uploadType !== "agency" && uploadType !== "msp") && (
                        <th>Select</th>)}
                      <th>Date & Time</th>
                      <th>Document</th>
                      <th></th>
                      {(uploadType !== "agency" && uploadType !== "msp") && (
                        <th>Notes</th>)}
                      <th>Size</th>
                      {(uploadType !== "agency" && uploadType !== "msp") && <>
                        <th>First Signed</th>
                        <th>{uploadType} Signed</th>
                      </>}

                      <th>Action</th>
                      {(uploadType !== "agency" && uploadType !== "msp") && (
                        <>
                          {/* <th>Uploaded</th> */}
                          <th>Status</th>
                        </>)}
                    </tr>
                  </thead>
                  <tbody>
                    {uploadType === "agency" || uploadType === "msp" ?
                      <>{sentAgencyMapDocuments
                        .filter(
                          (x) =>
                            x.uploadType !== "client" &&
                            x.uploadType !== "reporting" &&
                            x.uploadType !== "project" &&
                            x.uploadType !== "candidate" &&
                            x.uploadType !== "ProjectInfo" &&
                            x.updType !== "internal"
                        )
                        .map((item, key) => (
                          <tr>
                            {(uploadType !== "agency" && uploadType !== "msp") && (
                              <td>
                                <input
                                  type="checkbox"
                                  id={`chk${item.docId}`}
                                  name={`chk${item.docId}`}
                                  onChange={handleSendSelect}
                                  checked={item.sentStatus}

                                />
                              </td>)}
                            <td>
                              <Moment format="MMM Do YYYY">
                                {item.dateTime}
                              </Moment>
                              <br />
                              <Moment format="h:mm a">
                                {item.dateTime}
                              </Moment>
                            </td>
                            <td style={{ whiteSpace: "pre-wrap" }}>

                              <button
                                className="btn btn-link btn-sm text-left p-0"
                                title="Download File"
                                onClick={() => handleDownloadFile(item)}
                              >
                                {item.docName}
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn btn-link btn-sm text-left p-0"
                                title="Copy Link for Case Reports"
                                onClick={() => handleCopyClipboard(`DownloadDocLink/${item.docId}`)}
                              >

                                {copyItem === `${window.location.origin}/DownloadDocLink/${item.docId}` ? <span>Copied!</span>
                                  : <i class="fa fa-link" aria-hidden="true"></i>}
                              </button>
                            </td>
                            {(uploadType !== "agency" && uploadType !== "msp") && (
                              <td>
                                {getPopover(item.remarks)}
                              </td>)}
                            <td>
                              {item.docSize}
                            </td>

                            <td>
                              {(uploadType !== "agency" && uploadType !== "msp") && (
                                <>
                                  {item.sentStatus ? (
                                    <>
                                      <i
                                        className="fa fa-check mr-1"
                                        aria-hidden="true"
                                      ></i>
                                      {item.docModifiedName === "esign"
                                        ? "Sent by WF eSign"
                                        : "Sent"}

                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-sm btn-link p-0"
                                        onClick={() => handleSendDoc(item.docId)}
                                      >
                                        Send
                                      </button>

                                      {item.docType === "application/pdf" && (
                                        <a
                                          className="btn btn-sm btn-link p-0"
                                          target="blank"
                                          //onClick={() => handleSendeSignDoc(item.docId)}
                                          href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${item?.docId}_${(((uploadType === "Subcontractor" || uploadType === "Recruiter") && viewType !== "candidateList")
                                            || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask?.ciid : partnerCurrentWfTask?.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.docName}`}
                                        >
                                          WF eSign
                                        </a>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                              {!item.sentStatus && (
                                <button
                                  className="btn btn-sm btn-link p-0"
                                  onClick={() => handleDeleteDocument(item.docId)}
                                >
                                  Delete
                                </button>
                              )}
                              <br />
                              {item.sentDateTime && (
                                <Moment format="MMM Do YYYY">
                                  {item.sentDateTime}
                                </Moment>
                              )}
                            </td>
                            {(uploadType !== "agency" && uploadType !== "msp") && (
                              <>
                                {item.docModifiedName === "esign1" ? getSignedDocuments(item) : getReqUploadedDocs(item, "sent")}
                              </>
                            )}

                          </tr>
                        ))} </>
                      :
                      <>

                        {sortMergedDocs?.map((item, key) => (
                          <tr key={key}>
                            {item.__docType === "sent" ? (
                              <>
                                <td>
                                  <input
                                    type="checkbox"
                                    id={`chk${item.docId}`}
                                    name={`chk${item.docId}`}
                                    onChange={handleSendSelect}
                                    checked={item.sentStatus}
                                  />
                                </td>
                                <td>

                                  <Moment format="MMM Do YYYY">{item.dateTime}</Moment>
                                  <br />
                                  <Moment format="h:mm a">{item.dateTime}</Moment>
                                </td>
                                <td style={{ whiteSpace: "normal" }}>
                                  <button
                                    className="btn btn-link btn-sm text-left p-0"
                                    title="Download File"
                                    onClick={() => handleDownloadFile(item)}
                                  >
                                    {item.docName}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-link btn-sm text-left p-0"
                                    title="Copy Link for Case Reports"
                                    onClick={() => handleCopyClipboard(`/DownloadDocLink/${item.docId}`)}
                                  >
                                    {copyItem ===
                                      `${window.location.origin}/DownloadDocLink/${item.docId}` ? (
                                      <span>Copied!</span>
                                    ) : (
                                      <i className="fa fa-link" aria-hidden="true"></i>
                                    )}
                                  </button>
                                </td>
                                <td>{getPopover(item.remarks)}</td>
                                <td>{item.docSize}</td>
                                {(uploadType !== "agency" && uploadType !== "msp") && (
                                  <>
                                    <td>
                                      {(!item.sentStatus || item.docModifiedName === "esign") && (
                                        <>
                                          {item.docModifiedName === "esign" ? (
                                            <>{getSignedDocuments(item, "0")}</>
                                          ) : (
                                            item.docType === "application/pdf" && (
                                              <a
                                                className="btn btn-sm btn-link p-0"
                                                target="blank"
                                                href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${item?.docId}_${((uploadType === "Subcontractor" ||
                                                  uploadType === "Recruiter") &&
                                                  viewType !== "candidateList") ||
                                                  (uploadType === "Candidate" &&
                                                    viewType === "candidateList")
                                                  ? workflowTask?.ciid
                                                  : partnerCurrentWfTask?.ciid
                                                  }_${currentUser?.id}_${clientDetails?.clientId}_${item.docName
                                                  }_contract`}
                                              >
                                                WF eSign
                                              </a>
                                            )
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td>
                                      {(!item.sentStatus || item.docModifiedName === "esign") && (
                                        <>
                                          {item.docModifiedName === "esign" ? (
                                            getSignedDocuments(item, "1")
                                          ) : (
                                            <>
                                              <a
                                                className="btn btn-sm btn-link p-0"
                                                target="blank"
                                                href={`${process?.env?.REACT_APP_ESIGN_BASEURL}/${item?.docId}_${((uploadType === "Subcontractor" ||
                                                  uploadType === "Recruiter") &&
                                                  viewType !== "candidateList") ||
                                                  (uploadType === "Candidate" &&
                                                    viewType === "candidateList")
                                                  ? workflowTask?.ciid
                                                  : partnerCurrentWfTask?.ciid
                                                  }_${currentUser?.id}_${clientDetails?.clientId}_${item.docName
                                                  }_esign`}
                                              >
                                                WF eSign
                                              </a>
                                              <br />
                                              <span>Pending</span>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </>
                                )}
                                <td>
                                  {item.sentStatus ? (
                                    <>
                                      <i className="fa fa-check mr-1" aria-hidden="true"></i>
                                      {item.docModifiedName === "esign"
                                        ? "Sent by WF eSign"
                                        : "Sent"}
                                    </>
                                  ) : (
                                    <>
                                      {item.docModifiedName !== "esign" && (
                                        <button
                                          className="btn btn-sm btn-link p-0"
                                          onClick={() => handleSendDoc(item.docId)}
                                        >
                                          Send
                                        </button>
                                      )}
                                    </>
                                  )}
                                  {!item.sentStatus && (
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() => handleDeleteDocument(item.docId)}
                                    >
                                      Delete
                                    </button>
                                  )}
                                  <br />
                                  {item.sentDateTime && (
                                    <>
                                    <Moment format="MMM Do YYYY">{item.sentDateTime}</Moment>
                                    <br/>
                                    <Moment format="h:mm a">{item.sentDateTime}</Moment>
                                    </>
                                  )}
                                </td>
                                {getReqUploadedDocs(item, "sent")}
                              </>
                            ) : (
                              <>
                                <td>
                                  <input
                                    type="checkbox"
                                    id={`chk${item.id}`}
                                    name={`chk${item.id}`}
                                    onChange={handleSendSelect}
                                    checked={item.sendStatus}
                                  />
                                </td>
                                <td>
                                  <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
                                  <br />
                                  <Moment format="h:mm a">{item.addedDateTime}</Moment>
                                </td>
                                {getReqRefDocs(item)}
                                <td>
                                  <button
                                    className="btn btn-link btn-sm text-left p-0"
                                    title="Copy Link"
                                  >
                                    <i className="fa fa-link" aria-hidden="true"></i>
                                  </button>
                                </td>
                                <td>{getPopover(item.notes)}</td>
                                {getDocReqSize(item)}
                                <td></td>
                                <td></td>
                                <td>
                                  {item.sendStatus ? (
                                    <>
                                      <span>Sent</span>
                                      <br />
                                      {item.sentDateTime && (
                                       <>
                                        <Moment format="MMM Do YYYY">
                                          {item.sentDateTime}
                                        </Moment>
                                        <br/>
                                         <Moment format="h:mm a">
                                          {item.sentDateTime}
                                        </Moment>
                                       </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-link btn-sm p-0"
                                        onClick={() => handleSendReqDocument(item.id)}
                                      >
                                        Send
                                      </button>
                                      <button
                                        className="btn btn-link btn-sm p-0"
                                        onClick={() => handleDeleteReqDocument(item.id)}
                                      >
                                        Delete
                                      </button>
                                    </>
                                  )}
                                </td>
                                {getReqUploadedDocs(item, "req")}
                              </>
                            )}
                          </tr>
                        ))}
                      </>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Tab>
        {(uploadType !== "agency" && uploadType !== "msp" && pageModule === "review1") && (
          <Tab
            eventKey={4}
            title="Received"
            className="p-3 border"
            tabClassName="h4"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-striped align-items-center table-flush border">
                    <thead className="thead-light-green">
                      <tr>
                        <th>S.No.</th>
                        <th>Date & Time</th>
                        <th>Document</th>
                        <th>Notes</th>
                        <th>Action</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receviedDocumnets.map((item, key) => (
                        <tr>
                          <td>{key + 1}</td>
                          <td>
                            {
                              <Moment format="MMM Do YYYY, h:mm a">
                                {item.dateTime}
                              </Moment>
                            }
                          </td>
                          {/* <td>
                                {item.uploaderName}
                                <br />
                                {item.uploaderEmail}
                              </td> */}
                          <td style={{ whiteSpace: "pre-wrap" }}>
                            <button
                              className="btn btn-link btn-sm text-left"
                              title="Download File"
                              onClick={() => handleDownloadFile(item)}
                            >
                              {item.docName}
                            </button>
                          </td>
                          <td>{item.remarks}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={() =>
                                handleDeleteDocument(item.docId)
                              }
                            >
                              Delete
                            </button>
                          </td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              value={item.docStatus}
                              onChange={(e) => handleDocStatusChange(item.docId, e.target.value)}
                            >
                              <option value="">Select Status</option>
                              <option value="1">Approved</option>
                              <option value="0">Not Approved</option>
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Tab>
        )}
        {(uploadType !== "agency" && uploadType !== "msp") && (
          <Tab
            eventKey={5}
            title="Internal"
            className="p-3 border"
            tabClassName="h4"
          >
            <div className="row">
              <div className="col-md-12">
                <button
                  className="btn btn-sm btn-link pl-0"
                  onClick={handleDocumentLoad}
                >
                  Refresh
                </button>
              </div>
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-striped align-items-center table-flush border">
                    <thead className="thead-light-green">
                      <tr>
                        <th>S.No.</th>
                        <th>Date & Time</th>
                        <th>Document</th>
                        <th>Notes</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sentDocuments
                        .filter(
                          (x) =>
                            x.uploadType !== "client" &&
                            x.uploadType !== "reporting" &&
                            x.uploadType !== "project" &&
                            x.updType === "internal"
                        )
                        .map((item, key) => (
                          <tr>
                            <td>{key + 1}</td>
                            <td>
                              <Moment format="MMM Do YYYY, h:mm a">
                                {item.dateTime}
                              </Moment>
                            </td>
                            <td style={{ whiteSpace: "pre-wrap" }}>
                              <button
                                className="btn btn-link btn-sm text-left"
                                title="Download File"
                                onClick={() => handleDownloadFile(item)}
                              >
                                {item.docName}
                              </button>
                            </td>
                            <td>{getPopover(item.remarks)}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-link p-0"
                                onClick={() => handleDeleteDocument(item.docId)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Tab>
        )}
        <Tab
          eventKey={3}
          title="Deleted"
          className="p-3 border"
          tabClassName="h4"
        >
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table table-striped align-items-center table-flush border">
                  <thead className="thead-light-green">
                    <tr>
                      <th>S.No.</th>
                      <th>Date & Time</th>
                      <th>From</th>
                      <th>Document</th>
                      {(uploadType !== "agency" && uploadType !== "msp") && (
                        <th>Notes</th>)}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadType === "agency" || uploadType === "msp" ?
                      <>
                        {deletedAgencyMspDocumnets.map((item, key) => (
                          <tr>
                            <td>{key + 1}</td>
                            <td>
                              {
                                <Moment format="MMM Do YYYY, h:mm a">
                                  {item.dateTime}
                                </Moment>
                              }
                            </td>
                            <td>
                              {item.uploaderName}
                              <br />
                              {item.uploaderEmail}
                            </td>
                            <td style={{ whiteSpace: "pre-wrap" }}>
                              <button
                                className="btn btn-link btn-sm text-left"
                                title="Download File"
                                onClick={() => handleDownloadFile(item)}
                              >
                                {item.docName}
                              </button>
                            </td>
                            {(uploadType !== "agency" && uploadType !== "msp") && (
                              <td>{getPopover(item.remarks)}</td>)}
                            <td>
                              <button
                                className="btn btn-sm btn-link p-0"
                                onClick={() =>
                                  handleRollbackDocument(item.docId)
                                }
                              >
                                Rollback
                              </button>
                              <button
                                className="btn btn-sm btn-link p-0"
                                onClick={() =>
                                  handlePurgeDocument(item.docId)
                                }
                              >
                                Purge
                              </button>
                            </td>
                          </tr>
                        ))}
                      </> :
                      <>
                        {deletedDocumnets
                          .filter(
                            (x) =>
                              x.uploadType !== "msp" &&
                              x.uploadType !== "agency"
                          ).map((item, key) => (
                            <tr>
                              <td>{key + 1}</td>
                              <td>
                                {
                                  <Moment format="MMM Do YYYY, h:mm a">
                                    {item.dateTime}
                                  </Moment>
                                }
                              </td>
                              <td>
                                {item.uploaderName}
                                <br />
                                {item.uploaderEmail}
                              </td>
                              <td style={{ whiteSpace: "pre-wrap" }}>
                                <button
                                  className="btn btn-link btn-sm text-left"
                                  title="Download File"
                                  onClick={() => handleDownloadFile(item)}
                                >
                                  {item.docName}
                                </button>
                              </td>
                              <td>{getPopover(item.remarks)}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-link p-0"
                                  onClick={() =>
                                    handleRollbackDocument(item.docId)
                                  }
                                >
                                  Rollback
                                </button>
                                <button
                                  className="btn btn-sm btn-link p-0"
                                  onClick={() =>
                                    handlePurgeDocument(item.docId)
                                  }
                                >
                                  Purge
                                </button>
                              </td>
                            </tr>
                          ))}
                      </>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey={6}
          title="History"
          className="p-3 border"
          tabClassName="h4"
        >
          <div className="row">
            {(uploadType !== "agency" && uploadType !== "msp") &&
              <div className="col-md-4">
                <div className="card shadow-none border">
                  <div className="card-header p-3">
                    <span className="h4">Received</span>
                  </div>
                  <div className="card-body p-3">
                    <table>
                      <tbody>
                        {receviedDocumnets.filter(x => x.uploaderId === applicantObj?.id ||
                          (x.uploaderId === applicantObj?.subcontractor?.parentid) ||
                          (x.uploaderId === applicantObj?.recruiter?.parentid)).map((doc) => (
                            <tr>
                              <td>
                                <Moment format="MMM Do YYYY">
                                  {doc.dateTime}
                                </Moment>
                              </td>
                              <td className="text-wrap">
                                <button
                                  className="btn btn-link btn-sm text-left"
                                  title="Download File"
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.docName}
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}

            <div className="col-md-4">
              <div className="card shadow-none border">
                <div className="card-header p-3">
                  <span className="h4">Sent</span>
                </div>
                <div className="card-body p-3">
                  <table>
                    <tbody>
                      {sentDocuments
                        .filter(
                          (x) =>
                            x.uploadType !== "client" &&
                            x.uploadType !== "reporting" &&
                            x.uploadType !== "project" &&
                            x.uploadType !== "agency" &&
                            x.uploadType !== "msp" &&
                            x.updType !== "internal" &&
                            x.sentStatus === true
                        )
                        .map((doc) => (
                          <tr>
                            <td>
                              <Moment format="MMM Do YYYY">
                                {doc.dateTime}
                              </Moment>
                            </td>
                            <td className="text-wrap">
                              <button
                                className="btn btn-link btn-sm text-left"
                                title="Download File"
                                onClick={() => handleDownloadFile(doc)}
                              >
                                {doc.docName}
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {(uploadType !== "agency" && uploadType !== "msp") &&
              <div className="col-md-4">
                <div className="card shadow-none border">
                  <div className="card-header p-3">
                    <span className="h4">Internal</span>
                  </div>
                  <div className="card-body p-3">
                    <table>
                      <tbody>
                        {sentDocuments
                          .filter(
                            (x) =>
                              x.updType === "internal" &&
                              x.uploadType !== "reporting" &&
                              x.uploadType !== "project"
                          )
                          .map((doc) => (
                            <tr>
                              <td>
                                <Moment format="MMM Do YYYY">
                                  {doc.dateTime}
                                </Moment>
                              </td>
                              <td className="text-wrap">
                                <button
                                  className="btn btn-link btn-sm text-left"
                                  title="Download File"
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.docName}
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
            {(uploadType !== "Subcontractor" && uploadType !== "Recruiter") &&
              <div className="col-md-4">
                <div className="card shadow-none border">
                  <div className="card-header p-3">
                    <span className="h4">Agency/Client</span>
                  </div>
                  <div className="card-body p-3">
                    <table>
                      <tbody>
                        {clientDocs.map((doc) => (
                          <tr>
                            <td>
                              <Moment format="MMM Do YYYY">
                                {doc.dateTime}
                              </Moment>
                            </td>
                            <td className="text-wrap">
                              <button
                                className="btn btn-link btn-sm text-left"
                                title="Download File"
                                onClick={() => handleDownloadFile(doc)}
                              >
                                {doc.docName}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}
          </div>
        </Tab>
      </Tabs>

      {docShowHide && <CandidateReqDoc
        docShowHide={docShowHide}
        handleDocShowHide={handleDocShowHide}
        workItem={(((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList")
          || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask : partnerCurrentWfTask}
        sendType={sendType}
        uploadType={uploadType}
        applicantObj={applicantObj}
        viewType={viewType}
      ></CandidateReqDoc>}


      {showHide && <InternalReviewPopup
        showHide={showHide}
        handleModalShowHide={handleModalShowHide}
        handleSubmit={handleSubmit}
        selectedItem={selectedObj}
        handleEditComment={handleEditComment}
        viewType={viewType}
      ></InternalReviewPopup>}



      {/* {ViewformShowHide && <ViewFormModal
        viewFormShowHide={ViewformShowHide}
        handleViewForm={handleViewFormShowHide}
        workflowTask={(((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList")
          || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask : partnerCurrentWfTask}
        selectedForm={selectedForm}
      ></ViewFormModal>} */}


      {otherDocShowHide && <UploadOther
        handleOtherDocShowHide={handleOtherDocShowHide}
        otherDocShowHide={otherDocShowHide}
        workflowTask={(((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList")
          || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask : partnerCurrentWfTask}
        onReqDocs={onReqDocs}
        uploadType={uploadType}
        viewType={viewType}
        applicantObj={applicantObj}
      />}


      {contractShowHide && <GenerateContract
        showHide={contractShowHide}
        uploadType={uploadType}
        handleModalShowHide={handleContractShowHide}
        workflowTask={(((uploadType === "Subcontractor" || uploadType === "Recruiter" || uploadType === "agency" || uploadType === "msp") && viewType !== "candidateList")
          || (uploadType === "Candidate" && viewType === "candidateList")) ? workflowTask : partnerCurrentWfTask}
        app={app}
        applicantObj={applicantObj}
        viewType={viewType}
      ></GenerateContract>}
    </React.Fragment>
  );
}

export default Document;
